import { ParamMap } from "@angular/router";
import { Observable } from "rxjs";
import { Page } from "../page";
import { Criteria } from "./criteria/criteria";
import { InitSearch } from "./init-search";
import { SearchRequest } from "./search-request";

export abstract class SearchComponent<T> {
  public results!: Page<T>;

  public loading = false;
  public searchInProgress = false;

  public page = 0;
  public searchRequest: SearchRequest;

  constructor(criterias: Map<string, Criteria>) {
    this.searchRequest = new SearchRequest(criterias);
  }

  public addFilter(criteria: string, filterValue: string) {
    this.searchRequest.addFilter(criteria, filterValue);
    this.page = 0;

    this.refresh();
  }

  public clearFilter(criteria: string) {
    this.page = 0;
    this.searchRequest.clearFilter(criteria);

    this.refresh();
  }

  public displayFilter(criteria: string): string {
    return this.searchRequest.displayCriteriaValues(criteria);
  }

  public getQueryParams(): any {
    var queryParams = this.searchRequest.getQueryParams();

    queryParams.page = this.page;

    return queryParams;
  }

  public init(results: Page<T>, query: string) {
    this.searchRequest.query = query;
    this.results = results;
  }

  public next() {
    if (this.results.last) {
      return;
    }

    this.page = this.results.number + 1;

    this.refresh();
  }

  public previous() {
    if (this.results.first) {
      return;
    }

    this.page = this.results.number - 1;

    this.refresh();
  }

  public querySearch() {
    this.page = 0;
    this.search();
  }

  public abstract refresh(): void;

  public search() {
    this.loading = true;
    this.searchInProgress = true;
    
    this.onSearch(this.searchRequest, this.page)

      .subscribe({
        next: results => {
          this.loading = false;
          this.searchInProgress = false;
          this.results = results;
        }, error: e => {
          this.loading = false;
          this.searchInProgress = false;
        }
      });
  }

  public initWithParamMap(queryParam: ParamMap): void {
    this.searchRequest.initWithParamMap(queryParam);

    try {
      this.page = Number.parseInt(queryParam.get("page") || "0");
    } catch (e) {
      this.page = 0;
    }
  }

  public onSearchInit(initSearch: InitSearch<T>) {
    this.searchRequest.query = initSearch.query;
    this.results = initSearch.initialResults;
  }

  public onSearchKeyup(event: KeyboardEvent) {
    if (event.key != "Enter") {
      return;
    }

    this.querySearch();
  }

  public abstract onSearch(searchRequest: SearchRequest, page: number): Observable<Page<T>>;
}